export const AUTH_FAILURE = "AUTH_FAILURE";
export const OTHER_FAILURE = "OTHER_FAILURE";
export const EXPIRED_FAILURE = "EXPIRED_FAILURE";

export class OAuth2SessionError extends Error{
  constructor(message, cause) {
    super(message);
    this.cause = cause;
  }

  get expired() {
    return EXPIRED_FAILURE === this.message;
  }
}
